import styled from 'styled-components';
import { lighten } from 'polished';

import Section from '@/components/section';
import Title from '@/components/title';
import SubTitleBase from '@/components/sub-title';
import Paragraph from '@/components/paragraph'

const SubTitle = styled(SubTitleBase)`
  color: ${props => lighten(.05, props.theme.colors.brand.primary)};
`;

const Hero = () => {
  return (
    <Section>
      <Title>About Bidali</Title>
      <SubTitle>We are reimagining digital commerce.</SubTitle>
      <Paragraph maxSize="1.5em">Bidali helps businesses increase sales and eliminate fraud with next generation payments and more flexible gift cards.</Paragraph>
    </Section>
  );
};

export default Hero;
